import range from 'lodash/range'

export function updateValues (base, update) {
  const sRows = { }
  Object.keys(update).forEach(s => {
    sRows[s] = { ...base[s], ...update[s] }
  })

  return {
    ...base,
    ...sRows,
  }
}

export function extendDotRange ({ gridValues, toCell, rangeKey, scope }) {
  const { sMax, sMin, cMax, cMin } = scope
  if (toCell.s <= sMax && toCell.s >= sMin
    && toCell.c <= cMax && toCell.c >= cMin) {
    return {
      ...gridValues,
      [toCell.s]: {
        ...gridValues[toCell.s],
        [toCell.c]: rangeKey,
      },
    }
  }
  return gridValues
}

export function extendRectRange ({ gridValues, fromCell, toCell, rangeKey, scope }) {
  const { sMax, sMin, cMax, cMin } = scope
  const sStart = Math.max(fromCell.s, toCell.s, sMin)
  const sEnd = Math.min(fromCell.s, toCell.s, sMax)

  const cStart = Math.max(fromCell.c, toCell.c, cMin)
  const cEnd = Math.min(fromCell.c, toCell.c, cMax)

  const values = { }
  range(sStart, sEnd - 25, -25).forEach((s) => {
    const sRow = { }
    range(cStart, cEnd - 25, -25).forEach((c) => (
      sRow[c] = rangeKey
    ))
    values[s] = sRow
  })

  return updateValues(gridValues, values)
}

export function extendFillRange ({ gridValues, fromCell, toCell, scope, rangeKey }) {
  const sStart = Math.max(fromCell.s, toCell.s)
  const sEnd = scope.sMin

  const cStart = Math.max(fromCell.c, toCell.c)
  const cEnd = Math.min(fromCell.c, toCell.c)

  const values = { }
  range(sStart, sEnd - 25, -25).forEach((s) => {
    const sRow = { }
    range(cStart, cEnd - 25, -25).forEach((c) => (
      sRow[c] = rangeKey
    ))
    values[s] = sRow
  })

  return updateValues(gridValues, values)
}

function buildSlashValues ({ sStart, cStart, scope: { sMax, cMin }, rangeKey }) {
  // right-up direction

  // find shorter route length to scope edge
  const sDiff = sMax - sStart
  const cDiff = cStart - cMin

  const start = sDiff < cDiff ? sStart : cStart
  const end = sDiff < cDiff ? sMax : cMin
  const step = sDiff < cDiff ? 25 : -25

  // use shorter route to build values
  const values = { }
  range(start, end + step, step).reduce(({ s, c }) => {
    values[s] = values[s] || { }
    values[s][c] = rangeKey

    return {
      s: s + 25,
      c: c - 25,
    }
  }, { s: sStart, c: cStart })


  return values
}

export function extendSlashRange ({ gridValues, fromCell, toCell, scope, rangeKey }) {
  const sStart = Math.max(fromCell.s, toCell.s)
  const sEnd = Math.min(fromCell.s, toCell.s)

  const cStart = Math.max(fromCell.c, toCell.c)
  const cEnd = Math.min(fromCell.c, toCell.c)


  const sDirectionValues = range(sStart, sEnd - 25, -25).reduce((values, s) => (
    updateValues(
      values,
      buildSlashValues({
        sStart: s,
        cStart,
        scope,
        rangeKey,
      }),
    )
  ), { })

  const cDirectionValues = range(cStart, cEnd - 25, -25).reduce((values, c) => (
    updateValues(
      values,
      buildSlashValues({
        sStart: sEnd,
        cStart: c,
        scope,
        rangeKey,
      })
    )
  ), { })


  return updateValues(updateValues(gridValues, sDirectionValues), cDirectionValues)
}

export function extendCopyRange ({ gridValues, scope, rangeKey, fromRange }) {
  const { sMax, sMin, cMax, cMin } = scope
  const values = {}
  fromRange.forEach(({ s, c }) => {
    if (s <= sMax && s >= sMin && c <= cMax && c >= cMin) {
      values[s] = values[s] || {}
      values[s][c] = rangeKey
    }
  })

  return updateValues(gridValues, values)
}




// WEBPACK FOOTER //
// ./src/components/RangeEditor/calcExtendRange.js